<template>
  <div class="row app-wrapper">
    <sidebar :route="currentRoute" :class="sidebarClassName"></sidebar>
    <section class="app-content columns" :class="contentClassName">
      <router-view></router-view>
    </section>
  </div>
  <!-- Adding the chat-phone overlay to application -->
  <div class="row">
    <button class="open-button" v-on:click="openForm">Phone</button>
    <div class="chat-popup" id="myForm">
      <span class="close-btn" v-on:click="closeForm">&times;</span>
      <iframe src="https://10.1.101.172/ctiapp/" width="auto" height="500px" style="border: none"></iframe>
    </div>
  </div>
</template>
<script>
import Sidebar from '../../components/layout/Sidebar';

export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      isSidebarOpen: false,
      isOnDesktop: true,
    };
  },
  computed: {
    currentRoute() {
      return ' ';
    },
    sidebarClassName() {
      if (this.isOnDesktop) {
        return '';
      }
      if (this.isSidebarOpen) {
        return 'off-canvas is-open ';
      }
      return 'off-canvas position-left is-transition-push is-closed';
    },
    contentClassName() {
      if (this.isOnDesktop) {
        return '';
      }
      if (this.isSidebarOpen) {
        return 'off-canvas-content is-open-left has-transition-push has-position-left';
      }
      return 'off-canvas-content';
    },
  },
  mounted() {
    this.$store.dispatch('setCurrentAccountId', this.$route.params.accountId);
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    bus.$on('sidemenu_icon_click', () => {
      this.isSidebarOpen = !this.isSidebarOpen;
    });


  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      if (window.innerWidth > 1200) {
        this.isOnDesktop = true;
      } else {
        this.isOnDesktop = false;
      }
    },
    openForm() {
      document.getElementById("myForm").style.display = "block";
    },
    closeForm() {
      document.getElementById("myForm").style.display = "none";
    }
  },
};
</script>
<style>
iframe {
  border: none;
}

.open-button {
  background-color: #555;
  color: white;
  padding: 16px 20px;
  border: none;
  cursor: pointer;
  opacity: 0.8;
  position: fixed;
  bottom: 23px;
  right: 28px;
}

.chat-popup {
  display: none;
  position: fixed;
  bottom: 0;
  right: 15px;
  border: 3px solid #f1f1f1;
  z-index: 9;
  border-radius: 16px;
}

.form-container .btn:hover,
.open-button:hover {
  opacity: 1;
}

.close-btn {
  font-size: 35px;
  font-weight: bold;
  color: #000;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-right: 5px;
}
</style>